import { Helmet } from "react-helmet-async";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

const PolitykaPrywatnosci = () => (
  <div className="min-h-screen bg-background">
    <Helmet>
      <title>Polityka prywatności | WystepKabaretu.pl</title>
      <meta name="description" content="Polityka prywatności serwisu WystepKabaretu.pl - informacje o cookies, bezpieczeństwie danych i usługach zewnętrznych." />
      <link rel="canonical" href="https://wystepkabaretu.pl/polityka-prywatnosci" />
      <meta name="robots" content="index, follow" />
    </Helmet>
    <Navigation />
    <main className="container max-w-3xl py-16 px-4 pt-28">
      <h1 className="text-4xl font-montserrat font-black text-foreground mb-8">Polityka prywatności</h1>

      <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
        <h2 className="text-xl font-bold text-foreground mt-8">1. Informacje ogólne</h2>
        <p>Niniejsza polityka prywatności dotyczy serwisu internetowego WystepKabaretu.pl, którego właścicielem jest Wirtualny Biznes z siedzibą przy ul. Księcia Witolda 49/15, 50-202 Wrocław, NIP: 8961619199.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">2. Dane osobowe</h2>
        <p>Serwis zbiera dane osobowe wyłącznie w zakresie niezbędnym do świadczenia usług. Dane te obejmują: imię i nazwisko, adres e-mail, numer telefonu oraz treść wiadomości przesłanej za pośrednictwem formularza kontaktowego.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">3. Pliki cookies</h2>
        <p>Serwis wykorzystuje pliki cookies w celu:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Zapewnienia prawidłowego działania serwisu</li>
          <li>Prowadzenia analiz statystycznych dotyczących ruchu na stronie</li>
          <li>Dostosowania treści do preferencji użytkownika</li>
        </ul>
        <p>Użytkownik może w każdej chwili zmienić ustawienia dotyczące plików cookies w przeglądarce internetowej.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">4. Bezpieczeństwo danych</h2>
        <p>Administrator stosuje odpowiednie środki techniczne i organizacyjne zapewniające bezpieczeństwo przetwarzanych danych osobowych, w szczególności uniemożliwiające dostęp do nich osobom trzecim lub ich przetwarzanie z naruszeniem przepisów prawa.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">5. Przekazywanie danych</h2>
        <p>Dane osobowe nie są przekazywane do państw trzecich ani organizacji międzynarodowych. Mogą być udostępniane jedynie podmiotom uprawnionym na podstawie przepisów prawa.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">6. Usługi zewnętrzne</h2>
        <p>Serwis może korzystać z usług zewnętrznych dostawców (np. Google Analytics, hosting), którzy mogą przetwarzać dane osobowe zgodnie z własnymi politykami prywatności.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">7. Kontakt</h2>
        <p>W sprawach dotyczących polityki prywatności prosimy o kontakt: <a href="mailto:kontakt@wystepkabaretu.pl" className="text-accent hover:underline">kontakt@wystepkabaretu.pl</a>.</p>
      </div>
    </main>
    <Footer />
  </div>
);

export default PolitykaPrywatnosci;
